import isPlaywright from "src/constants/isPlaywright";
import ValidFileUploadTypes from "src/constants/validFileUploadTypes";

const getFilteredUploadFileTypes = (
	files: FileList | null,
	validFileUploadTypes = ValidFileUploadTypes,
) => {
	const validFiles: File[] = [];
	let numUnsupportedFiles = 0;
	const numUnsupportedFileTypes = new Set<string>();
	for (const file of files ?? []) {
		if (validFileUploadTypes.has(file.type) || (isPlaywright && !file.type)) {
			validFiles.push(file);
		} else {
			numUnsupportedFiles++;
			numUnsupportedFileTypes.add(file.type);
		}
	}

	return {
		validFiles: validFiles,
		numUnsupportedFiles: numUnsupportedFiles,
		unsupportedFileTypes: Array.from(numUnsupportedFileTypes),
	};
};

export default getFilteredUploadFileTypes;
